'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';
import AdBanner from '@/components/AdBanner';
import BoardList from '@/components/BoardList';
import PostHaulageJobPanel from '@/components/PostHaulageJobPanel';

/**
 * Haulage Job Board
 *
 * The body is BoardList, reading entries the FarmTradeDirect team adds in
 * Admin -> Boards. This page previously held a hardcoded array of five invented jobs with invented bids against them.
 */
export default function HaulageJobBoardScreen() {
  return (
    <main className="max-w-screen-2xl mx-auto px-4 lg:px-8 xl:px-10 py-8">
      <div className="mb-8">
        <h1 className="text-2xl md:text-3xl font-extrabold text-foreground">Haulage Job Board</h1>
        <p className="text-muted-foreground text-sm mt-2 max-w-2xl leading-relaxed">
          Livestock and machinery movements looking for a haulier. Every job here is listed by the FarmTradeDirect team &mdash; send an enquiry and we&apos;ll put you in touch.
        </p>
      </div>

      <PostHaulageJobPanel />

      <div className="flex items-start gap-3 bg-blue-50 border border-blue-200 rounded-xl px-5 py-4 mb-6">
        <Icon name="InformationCircleIcon" size={20} className="text-blue-600 shrink-0 mt-0.5" />
        <p className="text-sm text-blue-900">
          Hauliers: send an enquiry on any job below and we will put you in touch with whoever
          posted it.
        </p>
      </div>


      <BoardList
        board="haulage"
        emptyTitle="No haulage jobs on the board right now"
        emptyMessage="Jobs are added as they come in. If you have a movement you need covering, send us an enquiry and we will get it on the board."
        enquiryLabel="Enquire about this job"
      />

      <div className="mt-10">
        <AdBanner width={728} height={90} label="728x90 Leaderboard Banner" className="mx-auto rounded-lg" />
      </div>
    </main>
  );
}
